import { createAsyncThunk } from '@reduxjs/toolkit'
import apiEndpoints from '../../const/apiEndpoints'
import history from '../../const/history'
import ROUTES from '../../const/routes'
import api from '../../services'

export const getQrIdByScan = createAsyncThunk(
    'qrcode/sacn',
    async (scanId: any): Promise<any> => {
        const response = await api.get(`${apiEndpoints.getqrDetailsbyScan}${scanId}`)
        if (response.data) {
            history.push(ROUTES.QRVIDEO)
        }
        return response?.data
    }
)